import { Component } from '@angular/core';
import { AuthService, PageConfigService, PageLoadService, UtilityService, VariableService } from '../../../services';
import { SearchService } from '../../../services/search.service';

@Component({
    selector: 'app-footer-section',
    templateUrl: './footer-section.component.html',
    styleUrls: ['./footer-section.component.scss'],
    standalone: false
})
export class FooterSectionComponent {

  constructor(
    public authService: AuthService,
    public utilityService: UtilityService,
    public pageConfigService: PageConfigService,
    public pageLoadService: PageLoadService,
    public variableService: VariableService,
    public searchService: SearchService
  ) {

  }

  openCookieSetting() {
    const Cookiebot = (window as any).Cookiebot;
    if (typeof Cookiebot !== 'undefined') {
      Cookiebot.renew();
    } else {
      console.error('Cookiebot script not loaded.');
    }
  }
}
